import React, { useState, useEffect } from "react";
import { useParams, useLocation } from "react-router-dom";
import Unidades from "../context/Unidades";
import Image from "../img/whatsapp/WhatsApp.png";
import emailjs from "emailjs-com";
import ReCAPTCHA from "react-google-recaptcha";

const BtWhatsapp = ({ fixedNumber }) => {
  const { uf } = useParams();
  const location = useLocation();

  const [whatsapp, setWhatsapp] = useState("");
  const [textVisible, setTextVisible] = useState("hidden");
  const [showForm, setShowForm] = useState(false);
  const [isSending, setIsSending] = useState(false); // evita envio duplo
  const [captchaValue, setCaptchaValue] = useState(null);

  const [formData, setFormData] = useState({
    from_name: "",
    from_email: "",
    from_celular: "",
  });

  useEffect(() => {
    const whats = Unidades.renderTelVisivel(uf);
    if (whats.length > 0) {
      const rawPhone =
        fixedNumber ? fixedNumber : whats[0].contato.substring(1);

      const message =
        location.pathname ===
          `${process.env.PUBLIC_URL + "/" + uf + "/investigacao_empresarial"}`
          ? "Olá, estou interessado em discutir a possibilidade de contratar seus serviços de investigação empresarial!"
          : "";

      // Detecta mobile pelo userAgent (mais confiável que innerWidth)
      const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

      const link = isMobile
        // whatsapp:// abre o app diretamente no iOS e Android sem página intermediária
        ? `whatsapp://send?phone=${rawPhone}&text=${encodeURIComponent(message)}`
        : `https://web.whatsapp.com/send/?phone=${rawPhone}&text=${encodeURIComponent(message)}`;

      setWhatsapp(link);
    }
  }, [uf, location.pathname, fixedNumber]);

  useEffect(() => {
    const handleScroll = () => {
      setTextVisible(window.pageYOffset > 300 ? "visible" : "hidden");
    };
    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (isSending) return; // proteção contra duplo envio
    setIsSending(true);

    if (!captchaValue) {
      alert("❌ Por favor, marque a caixa do reCAPTCHA.");
      setIsSending(false);
      return;
    }

    const { from_name, from_email, from_celular } = formData;

    if (!from_name || !from_celular) {
      alert("❌ Preencha todos os campos antes de enviar.");
      setIsSending(false);
      return;
    }

    const isMobile = /iPhone|iPad|iPod|Android/i.test(navigator.userAgent);

    // No mobile usamos window.location.href com whatsapp:// (mesma aba).
    // Um novo tab (window.open) não consegue navegar para URI de app nativo.
    // No desktop abrimos about:blank ANTES do await para burlar o bloqueio
    // de popup do Safari (que requer gesto direto do usuário).
    const whatsappWindow = isMobile ? null : window.open("about:blank", "_blank");

    const params = {
      from_name,
      from_email,
      from_celular,
      from_mensagem: `Solicitação de contato via botão WhatsApp - UF: ${uf}`,
    };

    try {
      await emailjs.send(
        "service_5xppix8",
        "template_wvhr62g",
        params,
        "7slxx2CDeue4Apnbj"
      );

      setShowForm(false);
      setFormData({
        from_name: "",
        from_email: "",
        from_celular: "",
      });

      if (isMobile) {
        // whatsapp:// abre o app diretamente no iOS e Android
        window.location.href = whatsapp;
      } else if (whatsappWindow) {
        whatsappWindow.location.href = whatsapp;
      } else {
        window.location.href = whatsapp;
      }
    } catch (err) {
      // Fecha a janela em branco se o envio falhou
      if (whatsappWindow) whatsappWindow.close();
      alert("❌ Falha ao enviar. Tente novamente.");
      console.error(err);
    } finally {
      setIsSending(false);
    }
  };

  const handleClick = (e) => {
    e.preventDefault(); // impede que o <a> abra o WhatsApp
    setShowForm(true);
  };

  return (
    <>
      <div className="whats-div">
        <a
          href="#"
          className="whats-btn"
          onClick={handleClick}
        >
          <img src={Image} alt="WhatsApp Icon" className="whats-icon" />
          <span className="whats-btn-text" style={{ visibility: textVisible }}>
            Fale conosco pelo WhatsApp
          </span>
        </a>
      </div>

      {showForm && (
        <div className="modal-overlay">
          <div className="modal-content">
            <h2>Fale Conosco</h2>
            <p className="modal-subtitle">
              Preencha os dados e fale com um detetive agora
            </p>

            <form onSubmit={handleSubmit} className="form-container">
              <input
                type="text"
                placeholder="Nome"
                value={formData.from_name}
                onChange={(e) =>
                  setFormData({ ...formData, from_name: e.target.value })
                }
                required
              />

              {/* <input
                type="email"
                placeholder="Email"
                value={formData.from_email}
                onChange={(e) =>
                  setFormData({ ...formData, from_email: e.target.value })
                }
                required
              /> */}

              <input
                type="number"
                placeholder="WhatsApp com DDD"
                value={formData.from_celular}
                onChange={(e) =>
                  setFormData({ ...formData, from_celular: e.target.value })
                }
                required
              />

              <div style={{ margin: "10px 0", display: "flex", justifyContent: "center" }}>
                <ReCAPTCHA
                  sitekey="6LfeJR0tAAAAAM5YBsFbLP2O6K_MK2Oka-9FwCFd"
                  onChange={(val) => setCaptchaValue(val)}
                />
              </div>

              <div className="btn-group">
                <button type="submit" className="btn-send" disabled={isSending}>
                  {isSending ? "Enviando..." : "Enviar e abrir WhatsApp"}
                </button>

                {/* <button
                  type="button"
                  className="btn-cancel"
                  onClick={() => setShowForm(false)}
                >
                  Cancelar
                </button> */}
              </div>
            </form>
          </div>
        </div>
      )}
    </>
  );
};

export default BtWhatsapp;
